export default "__VITE_ASSET__y$wqG$eN__"